// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZoomInOutlinedSvg from "@ant-design/icons-svg/es/asn/ZoomInOutlined";
import AntdIcon from '../components/AntdIcon';

var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZoomInOutlinedSvg
  }));
};

ZoomInOutlined.displayName = 'ZoomInOutlined';
export default React.forwardRef(ZoomInOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ZoomInOutlined.js
// module id = 2093
// module chunks = 0